<template>
  <div class="group-con">
    <div class="avatar-con" v-for="(item, index) in arr" :key="index">
      <img :src="item || 'http://image.xinli001.com/images/avatar.jpg!80'" alt="壹心理直播-观看人数">
    </div>
    <div v-show="sum" class="num">
      {{ sum | millionNum }}
    </div>

  </div>
</template>

<script>
  export default {
    name: "AvatarGroup",
    props: {
      avatarArr: {
        type: Array,
        default: () => []
      },
      sum: {
        type: Number,
        default: 0
      }
    },
    computed: {
      arr() {
        let temp = []
        let avatarArr = this.avatarArr
        if (avatarArr.length <= 3) {
          temp = avatarArr
        } else {
          temp = avatarArr.slice(avatarArr.length-3)
        }
        return temp.reverse()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .group-con {
    display: flex;
    justify-content: flex-start;

    .avatar-con:nth-child(1) {
      z-index: 30;
    }

    .avatar-con:nth-child(2) {
      z-index: 20;
    }

    .avatar-con:nth-child(3) {
      z-index: 10;
    }

    .avatar-con:nth-child(4) {
      z-index: 30;
    }
  }

  .avatar-con {
    margin-left: -15px;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border: 1px solid #fff;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }

  .num {
    margin-left: -15px;
    padding: 0 15px;
    height: 48px;

    background-color: rgba(0, 0, 0, .3);
    text-align: center;
    line-height: 48px;
    border-radius: 24px;
    border: 1px solid #fff;
    overflow: hidden;
    font-size: 20px;
  }
</style>